import React from 'react';
import { ConfigWrapper } from './styled';
import Content from './Content';

const ErrorLogicConfig = () => (
  <ConfigWrapper style={{ margin: 0 }}>
      <Content />
  </ConfigWrapper>
);

export default ErrorLogicConfig;
